<template>
	<div class="house">
		<div class="group-content">
			<van-swipe-cell
				v-for="(item,ind) in houseList"
				:key="ind">

				<van-card
					:thumb="item.pic?(item.pic.indexOf('http')==-1?(attach_url+item.pic):item.pic):''"
					:style="'margin-bottom:10px;'"
				>
					<template #title>
						<span style="font-weight:bold;">{{item.name}}</span> <span class="skin_color">{{item.direction}}</span>
					</template>
					<template #desc>
						<div :style="{'padding':'5px 0px'}">
						{{item.note||''}}
						</div>
					</template>
					<template #tags v-if="item.imgs">
						<div :style="{'padding':'5px 2px'}">
							<img :src="attach_url+uri" v-for="(uri,i) in item.imgs.split(',')" :key="i" :style="{height:'30px','margin-right':'5px'}" @click.stop="previewImg(item.imgs, i)"/>
						</div>
					</template>
					<template #num v-if="!readonly && p_id!=pdg_p_id">
						<van-tag type="danger" @click.stop="onAddChild(item.name)">创建子谱</van-tag>
					</template>
					<template #price>
						<van-tag plain type="warning">{{markColumns[item.types-1]}}</van-tag>
					</template>
					<template #origin-price>
						<span>{{item.personals?item.personals.split(';')[1]:''}}</span>
					</template>
					<template #footer>
						建于 {{item.date_house?item.date_house:item.date_build}} {{item.date_finished?('，完成于 '+item.date_finished):''}}
					</template>
				</van-card>

				<template #right>
					<van-button square text="编辑" type="primary" @click="onEditHouse(item.id)" v-if="!readonly"/>
					<van-button square text="账务" type="primary" @click="onEditHouseFinance(item.id)"/>
					<van-button square text="修葺" type="primary" @click="onEditHouseRepair(item.id)"/>
					<van-button square text="删除" type="danger" @click="onDelHouse(item.id)" v-if="!readonly"/>
				</template>

			</van-swipe-cell>

			<div class="empty" v-if="houseList.length==0">
				<span class="msg">没有相关信息！</span>
			</div>
		</div>

		<van-popup v-model="showEditHouse" round position="bottom" :style="{ 'max-height': '80%', 'bottom':'50px', 'padding-top':'20px'}">
			<van-row style="margin-bottom:5px;">
				<van-col span="18">
				<van-field
						v-model.trim="houseInfo.name"
						label="住宅名称："
						required
						placeholder="请输入住宅名称"
						clearable
					></van-field>
					<van-field
						v-model.trim="houseInfo.direction"
						label="住宅坐向："
						placeholder="请输入住宅坐向"
						clearable
					></van-field>
				</van-col>
				<van-col span="6" style="background-color:#fff;">
					<van-uploader ref="clansHouseUploader" max-count="1" v-model="imgList" :max-size="imgSizeLimit" @oversize="onOversize" :after-read="afterReadImg" :before-read="beforeRead"/>
				</van-col>
			</van-row>
			<van-cell-group > 
				<van-cell
					title="类型："
					is-link
					:value="markColumns[houseInfo.types-1]"
					title-class="van-cell-title"
					@click="showPicker=2"
				>
				</van-cell>
				<van-field
					v-model.trim="houseInfo.note"
					:label="markColumns[houseInfo.types-1]+'简要：'"
					placeholder="请输入简要内容"
					clearable
					v-if="houseInfo.types>1"
				></van-field>
				<van-cell title="置业时间：" title-class="van-field__label">
					<template #default>建于 {{houseInfo.date_house?houseInfo.date_house:houseInfo.date_build}} {{houseInfo.date_finished?('，完成于 '+houseInfo.date_finished):''}}</template>
					<template #right-icon><van-button type="default" plain hairline size="mini" @click.stop="showPopup2HouseTime" :style="{'margin-left':'5px'}">选 / 填</van-button></template>
				</van-cell>

				<van-field
					v-model.trim="houseInfo.address"
					label="住宅地址："
					placeholder="请输入住宅地址"
					clearable
				@blur="locationAmapByAddress(houseInfo.address)"
				></van-field>

				<div id="amap_container_house" class="amap_container"></div>

				<van-field
				  v-model.trim="houseInfo.remark"
				  rows="5"
				  label="备注："
				  type="textarea"
				  maxlength="3000"
				  placeholder="请输入备注内容"
				  show-word-limit
				/>

				<van-cell title="图片：" title-class="van-field__label">
					<template #default>
						<van-uploader ref="clansHouseUploader2" v-model="imgList2" max-count="5" :max-size="imgSizeLimit" @oversize="onOversize" :after-read="afterReadImg2" :before-read="beforeRead"/>
					</template>
				</van-cell>

				<van-divider v-if="houseInfo.types>2">
					其他{{markColumns[houseInfo.types-1]}}人
					<van-icon name="add" @click="showHouseRelatPopup=true"  class="color_red" :style="{'margin-left':'20px'}"/>
				</van-divider>
				<van-row :style="{'margin-bottom':'10px'}">
					<van-col span="24" :style="{'text-align':'left'}">
						<van-tag type="warning" closeable  v-for="(n, i) in housePersonalName" :key="i" @close="removeHousePersonal(i)" :style="{margin:'5px 10px'}">{{n}}</van-tag>
					</van-col>
				</van-row>


				<van-row  :style="{'margin-bottom':'10px'}">
					<van-col span="1"></van-col>
					<van-col span="9">
						<van-button type="default" block  @click="showEditHouse=false">取消</van-button>
					</van-col>
					<van-col span="1"></van-col>
					<van-col span="12">
						<van-button type="primary" block  @click="onSaveHouse">保存</van-button>
					</van-col>
					<van-col span="1"></van-col>
				</van-row> 

			</van-cell-group>

		</van-popup>

		<van-popup v-model="showPicker" position="bottom">
		  <van-picker
			show-toolbar
			title="请选择"
			:columns="markColumns"
			@cancel="showPicker = false"
			@confirm="onMarkConfirm"
		  />
		</van-popup>

		<van-popup v-model="showHouseTimePopup" position="bottom" :style="{'min-height':'200px', 'bottom':'50px'}">

			<van-row  :style="{'margin-bottom':'10px'}">
				<van-col span="5">
					<van-sidebar v-model="sidebarActiveKey">
						<van-sidebar-item title="选择日期" />
						<van-sidebar-item title="手动输入" />
					</van-sidebar>
				</van-col>
				<van-col span="19">
					<van-cell-group > 
						<van-field
							v-model.trim="houseInfo.date_house"
							label=""
							placeholder="请输入置业时间"
							clearable
						v-if="sidebarActiveKey==1"
						></van-field>

						<van-cell
							title="始建日期："
							is-link
							:value="houseInfo.date_build"
							title-class="van-cell-title"
							v-if="sidebarActiveKey==0"
							@click="showHouseTimePicker=1"
						>
							<template #right-icon>
								<van-icon name="arrow" class="van-cell__right-icon" />
								<van-button type="default" plain hairline size="mini" @click.stop="houseInfo.date_build=''" :style="{'margin-left':'5px'}">置空</van-button>
							</template>
						</van-cell>
						<van-cell
							title="完工日期："
							is-link
							:value="houseInfo.date_finished"
							title-class="van-cell-title"
							v-if="sidebarActiveKey==0"
							@click="showHouseTimePicker=2"
						>
							<template #right-icon>
								<van-icon name="arrow" class="van-cell__right-icon" />
								<van-button type="default" plain hairline size="mini" @click.stop="houseInfo.date_finished=''" :style="{'margin-left':'5px'}">置空</van-button>
							</template>
						</van-cell> 
					</van-cell-group > 
				</van-col>
			</van-row> 
			<van-row  :style="{'margin-bottom':'10px'}" v-if="sidebarActiveKey==0&&showHouseTimePicker>0">
				<van-col span="24">
					<van-cell-group>
						<van-datetime-picker
							type="date"
							:title="showHouseTimePicker==1?'始建日期':'完工日期'"
							:min-date="new Date(1900, 0, 1)"
							:max-date="new Date()"
							
							@confirm="onConfirmHouseTime"
							@cancel="showHouseTimePicker=0"
						/>
					</van-cell-group > 
				</van-col>
			</van-row> 
			<van-row  :style="{'margin-bottom':'10px'}">
				<van-col span="1"></van-col>
				<van-col span="22">
					<van-button type="primary" block  @click="showHouseTimePopup=false" :disabled="sidebarActiveKey==0&&showHouseTimePicker>0">确定</van-button>
				</van-col>
				<van-col span="1"></van-col>
			</van-row> 
			
		</van-popup>

		<van-button square text="新增" type="default" class="btn_add" @click="onAddHouse" v-if="!readonly"/>

		<van-popup v-model="showHouseFinancePopup" position="bottom" closeable close-icon="close" :style="{'min-height':'200px', 'bottom':'50px','padding-top':'40px'}">
			<finance :fid="houseId" :types="'house'" :readonly="readonly"></finance>
		</van-popup>

		<van-popup v-model="showHouseRepairPopup" position="bottom" closeable close-icon="close" :style="{'min-height':'200px', 'bottom':'50px','padding-top':'40px'}">
			<house-repair :h_id="houseId" :readonly="readonly"></house-repair>
		</van-popup>

		<van-popup v-model="showHouseRelatPopup" position="bottom" :style="{'min-height':'200px', 'max-height':'80%', 'bottom':'50px'}">
			<van-cell-group > 
				<van-field
					v-model.trim="relativeKey"
					label="名字："
					placeholder="请输入名字"
					clearable
				>
					<template #button>
						<van-button size="small" type="primary" @click="qryPersonal2House">查询</van-button>
					</template>
				</van-field>
			</van-cell-group>

			<div class="empty" v-if="relativeList.length==0">
				<span class="msg">{{relativeKey2==''?'请输入名字查询':('未查询到与 '+relativeKey2+' 相关人')}}</span>
			</div>

			<van-checkbox-group v-model="relativeChecks">
				<van-cell-group inset>
					<van-list
					v-model="loading"
					:finished="finished"
					:finished-text="relativeList.length==0?'暂无数据':''"
					@load="getPersonal2House"
					>
						<van-cell title-class="van-cell-title" clickable :title="item.name" v-for="(item, ind) in relativeList" :key="ind" @click="relativeToggle(ind)" v-if="p_id!=item.id">
							<template #right-icon>
								<van-checkbox :name="item.id+';'+item.name" :ref="'relativeChecksRefs_'+ind" @click.stop/>
							</template>
						</van-cell>
					</van-list>
				</van-cell-group>
			</van-checkbox-group>
 
			<van-row  :style="{'margin-bottom':'10px'}">
				<van-col span="1"></van-col>
				<van-col span="22">
					<van-button type="primary" block  @click="confirmRelativeCheck">确定</van-button>
				</van-col>
				<van-col span="1"></van-col>
			</van-row> 
		</van-popup>

	</div>
</template>

<script>
import {Card, SwipeCell, Sidebar, SidebarItem, DatetimePicker,ImagePreview,Divider,List } from "vant";
import { chkImgType } from "@/utils/common.js";
import Finance from "@/components/Clans/Finance";
import HouseRepair from "@/components/Clans/HouseRepair";

export default {
	name: "clans_house",
	components: {
		"van-card":Card,
		"van-swipe-cell":SwipeCell,
		"van-sidebar":Sidebar,
		"van-sidebar-item":SidebarItem,
		"van-datetime-picker":DatetimePicker,
		"van-divider":Divider,
		"van-list":List,
		"finance":Finance,
		"house-repair":HouseRepair
	},
	props:{
		p_id:Number,
		pdg_p_id:Number,
		pdg_num:String,
		readonly:Boolean
	},
	data() {
		return {
			title: "置业信息管理",
			u_id: localStorage.getItem("u_id"),
			token: localStorage.getItem(localStorage.getItem("u_id") + "token"),
			attach_url:this.Conf.serverPre,

			houseList:[],
			houseInfoObj:{},
			showEditHouse:false,
			houseInfo:{},
			housePersonalId:[],
			housePersonalName:[],
			preAddress:'',
			showPicker:false,
			markColumns:['自建','购买','合建','合购'],
			showHouseTimePopup:false,
			sidebarActiveKey:0,
			showHouseTimePicker:0,
			
			imgList:[],
			imgList2:[],
			imgSizeLimit:500 * 1024,
			amap:null,
			amapGeocoder:{},
			amapMarker:false,
			saveFlag:false,
	
			showHouseFinancePopup:false,
			houseId:0,
			showHouseRepairPopup:false,

			relativeKey:'',
			relativeKey2:'',
			showHouseRelatPopup:false,
			relativeChecks:[],
			relativeChecksRefs:[],
			relativeList:[],

			page:0,
			pageSize:0,
			total:0,
			loading: false,
			finished: false,
			refreshing: false
		};
	},
	created() {
		this.getStateConfigs();
		this.getHouseData();
		
	},
	computed: {
	},
	methods: {
		initAmapByCity(cityad){
			this.locationAmapByAddress(cityad)
		},
		markerAmap(lnglat,reset){
			if(this.amapMarker){
				this.amap.remove(this.amapMarker);
			}
			this.amapMarker = new AMap.Marker();
			this.amapMarker.setPosition(lnglat);
			this.amap.add(this.amapMarker);
			this.amap.setFitView(this.amapMarker);
			this.houseInfo['lnglat'] = lnglat[0] + ',' + lnglat[1];
			if(reset){
				this.resetAddressByLnglat(lnglat);
			}
		},
		resetAddressByLnglat(lnglat){
			var geocoder = new AMap.Geocoder({
				city: ''
			})
			let that = this;
			geocoder.getAddress(lnglat, function (status, data) {
				if (status === 'complete' && data.info === 'OK') {
					// result为对应的地理位置详细信息
					//console.log(data)
					let faddress = data.regeocode.formattedAddress;
					let acomp = data.regeocode.addressComponent;
					let district = acomp.district;
					let fadr = faddress.split(district);
					that.$delete(fadr, 0);
					that.houseInfo.address = fadr.join(district);
					that.$forceUpdate();
				}
			})

		},
		locationAmapByAddress(ads){
			if(ads && ads != this.preAddress){
				let that = this;
				this.amapGeocoder.getLocation(ads, function(status, result) {
					if (status === 'complete'&&result.geocodes.length) {
						let local = result.geocodes[0].location;
						that.markerAmap([local.lng, local.lat],0);
					}else{
						that.$toast.fail("地址定位失败，请手动指定");
					}
				});
			}
		},
		getStateConfigs(){
			const confs = this.$store.state.common.configs;
			if(confs){
				if(confs.attach_url){
					this.attach_url = confs.attach_url.values;
				}
			}else{
				setTimeout(() => {
					this.getStateConfigs();
				},1000);
			}
		},
		beforeRead(file){
			return chkImgType(file);
		},
		onOversize(){
			this.$toast.fail("图片大小不能超过 500kb");
		},
		afterReadImg(file){
			this.houseInfo['new_pic'] = file.content
			this.imgList = [{url:file.content, isImage: true}];
		},
		afterReadImg2(file){
			//this.imgList2.push({url:file.content, isImage: true});
		},
		getHouseData(){
			var params = {
				u_id:this.u_id,
				token:this.token,
				p_id:this.p_id,
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/personalHouse" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.houseList = [];
				that.houseInfoObj = {};
				let datas = response.data.datas;
				if(datas && datas.length > 0){
					that.houseList = datas;
					for(var i=0,il=datas.length; i<il; i++){
						that.houseInfoObj[datas[i]['id']] = datas[i];
					};
				}
			})
			.catch(error => {});
		},
		onMarkConfirm(val,ind){
			this.houseInfo.types = ind+1;
			this.showPicker = false;
		},
		showPopup2HouseTime(){
			this.showHouseTimePopup = true;
			this.sidebarActiveKey = this.houseInfo.date_house?1:0;
		},
		initMaap(){
			let that = this;
			if(this.amap==null){
				this.$nextTick(() => {
					that.amap = new AMap.Map("amap_container_house", {
						resizeEnable: true
					});
					if(!that.readonly){
						that.amap.on('click', function(e) {
							that.markerAmap([e.lnglat.getLng(), e.lnglat.getLat()],1);
						});
					}
					that.amapGeocoder = new AMap.Geocoder({
						city:''//cityad
					});
					
				});
			}
		},
		onAddHouse(){
			this.houseInfo = {p_id:this.p_id, types:1};
			this.preAddress = '';
			this.imgList = [];
			this.imgList2 = [];
			this.initMaap();
			this.showEditHouse = true;
		},
		onEditHouse(id){
			this.houseInfo = this.houseInfoObj[id];
			this.housePersonalId = [];
			this.housePersonalName = [];
			this.preAddress = this.houseInfo.address;
			this.imgList = [];
			this.imgList2 = [];
			this.showEditHouse = true;
			if(this.houseInfo.pic){			
				this.imgList = [{url:this.houseInfo.pic.indexOf('http')==-1?(this.attach_url+this.houseInfo.pic):this.houseInfo.pic, isImage: true}];
			}
			if(this.houseInfo.imgs){	
				let imgs = this.houseInfo.imgs.split(',');
				for(var i=0,il=imgs.length; i<il; i++){
					this.imgList2.push({url:imgs[i].indexOf('http')==-1?(this.attach_url+imgs[i]):imgs[i], isImage: true});
				}
			}
			let psrs = this.houseInfo.personals;
			if(psrs){
				psrs = psrs.split(";");
				if(psrs && psrs.length ==2){
					this.housePersonalId = psrs[0].split(",");
					this.housePersonalName = psrs[1].split(",");
				}
			}
			this.initMaap();
			let that = this;
			if(this.houseInfo.lnglat){
				setTimeout(() => {
					that.markerAmap(that.houseInfo.lnglat.split(","),0);
				},1000);
			}
		},
		onDelHouse(id){
			this.$dialog
			.confirm({
				title: "温馨提醒",
				message: "删除后将不可恢复，确定？",
			})
			.then(() => {
				var params = {
					u_id:this.u_id,
					token:this.token,
					id:id
				};
				let that = this;
				var url = this.Conf.serverUrl + "clans/personalHouseDel" + "?num="+Math.random();
				this.$axios
				.post(url, this.$qs.stringify(params))
				.then(response => {
					that.$toast.success(response.data.msg);
					if(response.data.code == 200){
						that.getHouseData();
					}
				})
				.catch(error => {});
			})
			.catch((error) => {});
		},
		onSaveHouse(){
			if(this.saveFlag){
				this.$toast.fail("请求尚未响应，请勿重复提交！");
				return false;
			}
			if(!this.houseInfo['name']){
				this.$toast.fail("请输入住宅名称！");
				return false;
			}
			if(!this.houseInfo['date_house'] && !this.houseInfo['date_build']){
				this.$toast.fail("请输入/选择置业时间！");
				return false;
			}
			this.saveFlag = true;
			if(this.imgList.length > 0 && this.imgList[0].content){
				this.houseInfo['new_pic'] = this.imgList[0].content;
			}
			let phs = null;
			if(this.imgList2.length > 0){
				this.houseInfo['new_imgs'] = [];
				for(var i=0,il=this.imgList2.length; i<il; i++){
					if(this.imgList2[i].content){
						this.houseInfo['new_imgs'].push(this.imgList2[i].content);
					}else{
						phs = this.imgList2[i].url.split("/");
						this.houseInfo['new_imgs'].push(phs[phs.length-1]);
					}
				}
			}
			this.houseInfo['house_personal_id'] = this.housePersonalId;
			this.houseInfo['p_id'] = this.p_id;
			var params = {
				u_id:this.u_id,
				token:this.token,
				data:this.houseInfo
			};
			let that = this;
			var url = this.Conf.serverUrl + "clans/personalHouseSave" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				that.saveFlag = false;
				that.showHouseTimePopup = false;
				that.showEditHouse = false;
				that.$toast.success(response.data.msg);
				if(response.data.code == 200){
					that.getHouseData();
				}
			})
			.catch(error => {});
		},
		onConfirmHouseTime(val){
			if(this.showHouseTimePicker==1){
				this.houseInfo.date_build = this.$options.filters['moment_format'](val.getTime(),'Y-MM-DD');
			}else{
				this.houseInfo.date_finished = this.$options.filters['moment_format'](val.getTime(),'Y-MM-DD');
			}
			this.showHouseTimePicker=0;
			this.$forceUpdate();
		},
		onEditHouseFinance(h_id){
			this.houseId = h_id;
			this.showHouseFinancePopup = true;
		},
		onEditHouseRepair(h_id){
			this.houseId = h_id;
			this.showHouseRepairPopup = true;
		},
		onAddChild(n){
			this.$parent.$parent.$parent.$parent.$parent.onAddChildPedigree(this.p_id, n+'族谱');
		},
		previewImg(imgs, i){
			imgs = imgs.split(",");
			var imgarr = [];
			for(var ii in imgs){
				imgarr.push(this.attach_url+imgs[ii]);
			}
			ImagePreview({
				images: imgarr,
				startPosition: i,
				showIndex:false,
				showIndicators:true
			});
		},
		qryPersonal2House(){
			if(!this.relativeKey){
				this.$toast.fail("请输入查询名字！");
				return false;
			}
			this.getPersonal2House();
		},
		getPersonal2House(){
			if(!this.relativeKey){
				this.loading = false;
				return false;
			}
			this.relativeKey2 = this.relativeKey;
			
			this.page = this.page+1;
			var params = {
				u_id:this.u_id,
				token:this.token,
				pdg_num:this.pdg_num,
				personal_id:null,
				types:'personal',
				cons:{chkZodias:[],dateStr:'',dateBeg:'',dateEnd:'',inLaws:-1,health:-1}
			};
			params.page = this.page;
			params.cons['keyword'] = this.relativeKey;
			console.log(params)
			let that = this;
			var url = this.Conf.serverUrl + "clans/search" + "?num="+Math.random();
			this.$axios
			.post(url, this.$qs.stringify(params))
			.then(response => {
				this.loading = false;
				if(response.data.code == 40001){
					this.$toast.fail(response.data.msg);
				}else{
					if (response.data.page == 1) {
						this.pageSize = response.data.pageSize;
						this.total = response.data.total;
						this.relativeList = response.data.datas;
					}else{
						this.relativeList = this.relativeList.concat(response.data.datas);
					}
					if(this.page*this.pageSize >= this.total){
						this.finished = true;
					}
				}
			})
			.catch(error => {});
		},
		relativeToggle(i){
			this.$refs['relativeChecksRefs_'+i][0].toggle();
		},
		confirmRelativeCheck(){
			if(this.relativeChecks.length > 0){
				let tmp = null;
				for(var i=0,il=this.relativeChecks.length; i<il; i++){
					tmp = this.relativeChecks[i].split(';');
					if(this.housePersonalId.indexOf(tmp[0]) == -1){
						this.housePersonalId.push(tmp[0]);
						this.housePersonalName.push(tmp[1]);
					}
				}
			}
			this.showHouseRelatPopup = false;
		},
		removeHousePersonal(i){
			this.housePersonalId.splice(i,1);
			this.housePersonalName.splice(i,1);
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Clans/House.vue